import React, { useRef } from "react";
import { toPng } from "html-to-image";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import AccountAvatar from "../../../ui-components/account-avatar/account-avatar.tsx";
import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import TagElement from "../../../ui-components/tag-element/tag-element.tsx";
import { Size } from "../../../logic/enums.ts";

const DatingShareableComponent = ({ presignedUrl }) => {
  return (
    <div
      id="capture"
      className="flex flex-col gap-4 bg-color-dark-background-secondary border border-color-dark-border-primary p-4 w-full"
    >
      <div className="flex flex-col gap-4">
        <h4 className="font-black text-sm text-color-dark-text-secondary">
          SWIPE RIGHT
        </h4>
        <h2 className="font-bold text-3xl px-4">Good person, approved 🔥</h2>
        <h4 className="text-color-dark-text-secondary">@rhazsolomon</h4>
      </div>

      <div className="flex flex-col items-center justify-center relative">
        <RaindropCircle
          sausageValues={[
            {
              id: "a",
              value: 50,
              oldValue: 90,
              selected: false,
            },
            {
              id: "b",
              value: 13,
              oldValue: 10,
              selected: false,
            },
            {
              id: "c",
              value: 20,
              oldValue: 10,
              selected: false,
            },
            {
              id: "d",
              value: 17,
              oldValue: 10,
              selected: false,
            },
          ]}
          size="SMALL"
        />
        <div className="absolute">
          {
            <AccountAvatar
              presignedUrl={presignedUrl}
              isHuge={true}
              username={"TODO"}
            />
          }
        </div>
      </div>

      <h4 className="text-lg font-bold text-color-dark-text-secondary">
        Rhaz is supporting
      </h4>
      <div className="flex flex-wrap gap-4 items-center justify-center w-full ">
        <TagElement value={"ORGANISATION_TAG__MENTAL_HEALTH"} isSmall={true} />
        <TagElement value={"ORGANISATION_TAG__ANIMALS"} isSmall={true} />
        <TagElement value={"ORGANISATION_TAG__ENVIRONMENT"} isSmall={true} />
        <TagElement
          value={"ORGANISATION_TAG__MEDICAL_RESEARCH"}
          isSmall={true}
        />
      </div>

      <div className="opacity-30 pt-6">
        <RaindropTitle isPrimary={false} isSmall={true} />
      </div>
    </div>
  );
};

const RaindropDating = ({ userCurrent }) => {
  const componentRef = useRef();

  const onClick = () => {
    downloadImage();
  };

  const downloadImage = () => {
    const node = document.getElementById("capture");

    const imgElement = document.getElementById("account-img");
    if (imgElement === null) {
      return;
    }
    // Wait for the image to load before proceeding
    imgElement.onload = () => {
      toPng(node, { cacheBust: true, useCORS: true })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = "my_component.png";
          link.click();
        })
        .catch((error) => {
          console.error("Error generating PNG:", error);
        });
    };
    imgElement.src = userCurrent.account.presignedUrl; // Trigger image load
  };

  return (
    <div className="flex flex-col items-center gap-6 py-10 overflow-y-scroll">
      <div ref={componentRef}>
        <DatingShareableComponent
          presignedUrl={userCurrent.account.presignedUrl}
        />
      </div>

      <RaindropButton
        title={"Save"}
        style={ButtonStyle.Primary}
        size={Size.Large}
        isFluid={true}
        onClick={onClick}
      />
    </div>
  );
};

export default RaindropDating;
